import React from 'react';
import { CTAButton } from './CTAButton';
import { CHECKOUT_URL, OFFER_ANCHOR, PRODUCT_IMG } from './constants';
const includes = ['6 professional modules', '5 professional bonuses', 'Preventive maintenance workflows', 'Inspection checklists', 'Troubleshooting tools', 'Work-order systems', 'Professional maintenance references'];
export function PricingCard() {
  return <section id="offer" className="bg-brand-carbon px-4 py-5 text-white" data-id="element-134" data-mp="1i52a98lsm7w9">
      <div className="mx-auto max-w-2xl text-center" data-id="element-135" data-mp="2es6yrcmudnly">
        <p className="font-cond text-[12px] font-bold uppercase tracking-[0.2em] text-brand-yellow sm:text-sm" data-id="element-136" data-mp="29tlyxebi55y1">
          Special Launch Offer
        </p>
        <h2 className="font-display text-[22px] leading-tight text-white sm:text-4xl" data-id="element-137" data-mp="2512kyg8wk8sp">
          🔧 MAINTENANCE READY™
        </h2>
        <p className="mb-2 font-cond text-[13px] font-semibold uppercase leading-snug text-brand-line sm:text-base" data-id="element-138" data-mp="2xj80g8fcjx97">
          The Complete Ready-To-Use Maintenance System for Maintenance Professionals
        </p>

        <a href={OFFER_ANCHOR} className="block cursor-pointer" aria-label="Go to the offer" data-id="element-139" data-mp="32k2id6jj5x42">
          <img src={PRODUCT_IMG} alt="Maintenance Ready 6-in-1 system box set" className="mx-auto mb-2 w-full max-w-[200px] object-contain drop-shadow-2xl transition-transform duration-150 ease-out hover:scale-[1.02]" data-id="element-140" data-mp="37joutdrjb9bt" />
        </a>

        <div className="rounded-xl border-4 border-brand-yellow bg-white p-3.5 text-brand-carbon shadow-2xl sm:p-4" data-id="element-141" data-mp="2xs1arxxb4ukd">
          <p className="mb-1.5 font-cond text-[13px] font-bold uppercase tracking-wide" data-id="element-142" data-mp="2jvxiia5zuwaj">
            Complete 6-in-1 System
          </p>
          <ul className="mb-2.5 grid gap-x-4 gap-y-0.5 text-left text-[12px] font-semibold sm:grid-cols-2 sm:text-sm" data-id="element-143" data-mp="29w6mg41sc98c">
            {includes.map(item => <li key={item} data-id="element-144" data-mp="2ev9rvploghgu">✅ {item}</li>)}
          </ul>
          <p className="mb-2 font-display text-[18px] leading-tight sm:text-2xl" data-id="element-145" data-mp="83s8th69xqxq">
            🔥 Get MAINTENANCE READY™ Today —{' '}
            <span className="bg-brand-yellow px-1" data-id="element-146" data-mp="d23klxg4qbil">$26.90</span>
          </p>
          <CTAButton href={CHECKOUT_URL} data-id="element-147" data-mp="bmhka4mduhzl">🔧 GET INSTANT ACCESS</CTAButton>
          <p className="mt-1.5 text-[12px] font-semibold text-brand-muted" data-id="element-148" data-mp="6neeuj2hq9r3">
            Immediate Digital Access · 🛡️ 7-Day Money-Back Guarantee
          </p>
        </div>
      </div>
    </section>;
}